import * as model from './model.js';
import { MODAL_CLOSE_SEC } from './config.js';
import recipieView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';

import 'core-js/stable'; // polyfill everything else
import 'regenerator-runtime/runtime'; // polyfill async-await
import recipeView from './views/recipeView.js';

// https://forkify-api.herokuapp.com/v2

///////////////////////////////////////

// if(module.hot) module.hot.accept();

const controlRecipe = async function(){
  try{

    const id = window.location.hash.slice(1);
    console.log(id);
    
    if(!id) return;
    recipeView.renderSpinner();

    //0. Update results view to mark selected search result
    resultsView.update(model.getSearchResultsPage());
    bookmarksView.update(model.state.bookmarks);

    //1. Loading Recipe
    await model.loadRecipe(id);
    
    // 2. Rendering recipe
    recipieView.render(model.state.recipe);
   
  } catch (err) {
    console.log(err);
    recipeView.renderError();
  }

};

const controlSearchResults = async function(){
  try{
    resultsView.renderSpinner();

    //1. Get Search Query
    const query = searchView.getQuery();
    if(!query) return;

    //2. Load Search Query
    await model.loadSearchResults(query);

    //3. Render Results
    resultsView.render(model.getSearchResultsPage()); 

    //4. Render Initial Pagination Buttons
    paginationView.render(model.state.search);

  } catch(err){
    console.log(err);
  }
};

const controlPagination = function(goToPage){
  //1. Render New Results
    resultsView.render(model.getSearchResultsPage(goToPage)); 

    //2. Render New Pagination Buttons
    paginationView.render(model.state.search);
};

const controlServings = function(newServings){
  // Update recipie servings (in state)
  model.updateServings(newServings);

  // Update the recipe view
  // recipieView.render(model.state.recipe);
  recipieView.update(model.state.recipe);
}

const controlAddBookmark = function(){

  //1. Add/remove  bookmark
  if(!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  //2. Update Recipe view
  recipeView.update(model.state.recipe);

  //3. Render bookmarks
  bookmarksView.render(model.state.bookmarks);

}

const controlBookmarks = function(){
  bookmarksView.render(model.state.bookmarks);
}

const controlAddRecipe = async function(newRecipe){
  try{
    //Show loading spinner
    addRecipeView.renderSpinner();

    //Upload New Recipe Data
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    //Render Recipe
    recipeView.render(model.state.recipe);

    //Success Message
    addRecipeView.renderMessage();

    //Render Bookmark view
    bookmarksView.render(model.state.bookmarks);

    //change ID in url
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    //Close form window
    setTimeout(function(){
      addRecipeView.toggleWindow();
   }, MODAL_CLOSE_SEC * 1000);

  } catch(err){
    console.error(`💥💥 ${err}`);
    addRecipeView.renderError(err.message);
  }

}

const init = function(){
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);

};

init();